import { render } from "./ViewVendor.vue?vue&type=template&id=07593f94&scoped=true"
import script from "./ViewVendor.vue?vue&type=script&lang=js"
export * from "./ViewVendor.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=07593f94&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07593f94"]])

export default __exports__